// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__R+6S9","email":"Chip_email__xyY71","removeIcon":"Chip_removeIcon__gDFWF"};